import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import AsyncSelect from 'react-select/async'
import { useTranslation } from 'react-i18next'
import { fetchPuppetUsersList, setPuppetUser } from '../../common/app/actions'
import { Col, Row } from '.'

const PuppetUserSelect = ({
  fetchPuppetUsersList,
  puppetUser,
  setPuppetUser,
  onChange,
  viewer,
}) => {
  const { t } = useTranslation()

  const promiseOptions = useCallback(
    inputValue =>
      new Promise(async resolve => {
        const response = await fetchPuppetUsersList({ searchText: inputValue })
          .meta.action.payload

        const options = response.data.map(user => ({
          value: user._id,
          label: `${user.username} | ${user.name}`,
          username: user.username,
          _id: user._id,
        }))
        resolve(options)
      }),
    [fetchPuppetUsersList],
  )

  if (!viewer.canCreateOrdersForOthers) return null

  // common/helpers/setIn converts null to {}
  // this is temporary workaround before fix
  if (!puppetUser?.username) puppetUser = null

  return (
    <Row maxWidth="100%">
      <Col width="400px" style={{ zIndex: 1000 }}>
        <AsyncSelect
          cacheOptions
          loadOptions={promiseOptions}
          value={puppetUser}
          placeholder={t('Select user')}
          loadingMessage={() => t('Loading')}
          noOptionsMessage={() => t('No options')}
          isClearable
          onChange={data => {
            setPuppetUser(data)
            onChange()
          }}
        />
      </Col>
    </Row>
  )
}

const enhance = connect(
  ({ app }) => ({
    puppetUser: app.puppetUser,
    viewer: app.viewer,
  }),
  {
    fetchPuppetUsersList,
    setPuppetUser,
  },
)

export default enhance(PuppetUserSelect)
